import { getDefaultFilterOperators } from '@modules/reports/common';
import {
    getGridSingleSelectOperators,
    GridFilterOperator,
} from '@mui/x-data-grid-premium';
import { MUIDataType } from '@thought-river/negotiations-common/dist/api/contractContent';
import { ContractTreeColumn } from '@thought-river/negotiations-common/dist/api/contractManagement';

export const getFilterOperators = (
    column: ContractTreeColumn
): GridFilterOperator[] => {
    if (column.field === 'status') {
        const singleSelectOperators = getGridSingleSelectOperators();

        // Only allow `is any of` filtering for status
        return singleSelectOperators.filter(
            (operator) => operator.value === 'isAnyOf'
        );
    }

    // TODO: Backend should type column.type as MUIDataType to avoid casting
    return getDefaultFilterOperators(column.type as MUIDataType);
};
